import {
  DEFAULT_ENTITY_TYPE_GROUP_ORDER,
  ENTITY_TYPE_GROUPS,
  type TSelectableEntityType,
} from '../../EntityTypeSelector/EntityTypeSelector/entityTypeGroups';

export type UnheldTypeGroup = {
  title: string;
  entityTypes: TSelectableEntityType[];
};

/**
 * The entity types the customer holds none of, grouped as the entity type selector groups its
 * tiles: Organisation, Trust, Business, with the tiles of each group in the selector's own order.
 * The order the caller lists the types in does not matter. A group with no offered type is left out.
 */
export function groupUnheldTypes(
  unheld: readonly { entityType: TSelectableEntityType }[],
): UnheldTypeGroup[] {
  const offered = new Set(unheld.map(({ entityType }) => entityType));
  return DEFAULT_ENTITY_TYPE_GROUP_ORDER.map((key) => ENTITY_TYPE_GROUPS[key])
    .map(({ title, entityTypes }) => ({
      title,
      entityTypes: entityTypes.filter((entityType) => offered.has(entityType)),
    }))
    .filter(({ entityTypes }) => entityTypes.length > 0);
}
